// @ts-ignore
import {Table} from "react-bootstrap";
import React, {useEffect, useRef} from "react";


function SummaryTableRow({rowData, ...props}) {
    // console.log(rowData);
    // console.log(key);

    function precise(x, precision) {
        // @ts-ignore
        return Number.parseFloat(x).toFixed(precision);
        //return Number.parseFloat(x).toPrecision(4);
    }

    function separate(x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    // function niagaraLink(event, link) {
    //     // check if the N4 hyperlink function is there,
    //     // if not the anchor tag will behave as normal
    //     // @ts-ignore
    //     if (window.niagara && window.niagara.env && window.niagara.env.hyperlink) {
    //         // Tell the browser to not follow the anchor tag
    //         event.stopPropagation();
    //         event.preventDefault();
    //         // Use the Niagara hyperlink function to go to your ord
    //         // Note: use the actual ord here not the servlet /ord/ from the href
    //         // @ts-ignore
    //         window.niagara.env.hyperlink(link);
    //     }
    // }

    let station = rowData.stationName;
    let niagaraVersion = rowData.niagaraVersion;
    let status = rowData.status;
    let hyperlink = rowData.hyperlink;
    let downDeviceCount = rowData.downDeviceCount;
    let cpu = rowData.cpu;
    let heap = rowData.heap;
    let uptime = rowData.uptime;
    let overrides = rowData.overrides;
    let kpi = rowData.kpi;
    // let href = "/ord/station:%7C" + hyperlink + "|view:hesStationHealth:StationHealthProxyView";
    let href = hyperlink;
    // let link = "station:|" + hyperlink + "|view:hesStationHealth:StationHealthProxyView";

    return (
        <>
            <tr
                // className={
                //     (status.equals("down"))
                //         ? "station-down"
                //         : ""
                // }

            >
                {/* {
                    (status.equals("down"))
                    ? <td>{station}</td>
                    : 
                    <td><a href={href} className="a-hyp" 
                    onClick={(event) => {
                        niagaraLink(event, link);
                    }}
                    >{station}</a></td>
                } */}
                <td><a href={href} className="a-hyp" 

                    >{station}</a></td>
                <td>{niagaraVersion}</td>
                <td>{uptime}</td>
                <td>{precise(cpu, 1) + "%"}</td>
                <td>{precise(heap, 1) + "%"}</td>
                <td>{separate(precise(downDeviceCount, 0))}</td>
                <td>{separate(precise(overrides, 0))}</td>
                <td>{precise(kpi, 1)}</td>

            </tr>

        </>
    );
}


export default SummaryTableRow;
